module.exports = __webpack_public_path__ + "static/media/greencheer.1e55d48b.jpg";